import { Home, Users, UserPlus, BarChart3, Navigation } from 'lucide-react';

export interface NavigationItem {
  label: string;
  title?: string; // For dashboard cards
  description?: string; // For dashboard cards
  to: string;
  icon: typeof Home;
  showInNav?: boolean; // Default true
  showInDashboard?: boolean; // Default false
}

export const navigationItems: NavigationItem[] = [
  {
    label: 'Dashboard',
    to: '/',
    icon: Home,
    showInNav: true,
    showInDashboard: false,
  },
  {
    label: 'Users',
    title: 'Manage Users',
    description: 'Review accounts, inspect usage, and trigger admin actions.',
    to: '/users',
    icon: Users,
    showInNav: true,
    showInDashboard: true,
  },
  {
    label: 'Referrals',
    to: '/referrals',
    description: 'View referral links between users.',
    icon: UserPlus,
    showInNav: true,
    showInDashboard: true,
  },
  {
    label: 'AI Analytics',
    title: 'AI Analytics',
    description: 'Review accounts, inspect usage, and trigger admin actions.',
    to: '/ai-analytics',
    icon: BarChart3,
    showInNav: true,
    showInDashboard: true,
  },
  {
    label: 'Navigation History',
    title: 'Navigation History',
    description: 'View recent page navigations across all users.',
    to: '/navigation',
    icon: Navigation,
    showInNav: true,
    showInDashboard: true,
  },
];

// Helper functions to get filtered lists
export const getNavItems = () =>
  navigationItems.filter((item) => item.showInNav !== false);

export const getDashboardLinks = () =>
  navigationItems.filter((item) => item.showInDashboard === true);
